import { writable } from 'svelte/store';
export const SupportUser = writable(null);
export const Response = writable({});
export const isFormAlreadySubmitted = ()=>{
        let cookies = document.cookie.split(";");  
        let cookieFound = cookies.find(c => c.includes('formJustSubmitted'));
        return cookieFound
}
